import {HomeMatchPreleadStatus} from "@/features/home_match/types/HomeMatchPrelead";
import {View} from "@/features/km_app/types/View";

export enum AmplitudeButtonCategory {
    HOMEMATCH = "homematch",
    OFFER = "offer",
    KM_FAVOURITE = "km_favourite",
    KM_FAVOURITE_PICKER = "km_favourite_picker",
    KM_SENT_OFFERS = "hm_sent_offers",
    KM_SETTINGS = "km_settings",
    KM_REJECTED = "km_rejected",
    KM_OFFER_COMPARISON = "km_offer_comparison",
    KM_OFFER_DETAILS = "km_offer_details",
    KM_DASHBOARD = "km_dashboard",
    UNKNOWN = "unknown"
}

const viewToButtonCategoryMap: Partial<Record<View, AmplitudeButtonCategory>> = {
    [View.HOME_MATCH]: AmplitudeButtonCategory.HOMEMATCH,
    [View.FAVORITE]: AmplitudeButtonCategory.KM_FAVOURITE,
    [View.DISMISSED]: AmplitudeButtonCategory.KM_REJECTED,
    [View.APPLICATION_SENT]: AmplitudeButtonCategory.KM_SENT_OFFERS,
    [View.COMPARATOR]: AmplitudeButtonCategory.KM_OFFER_COMPARISON,
    [View.DASHBOARD]: AmplitudeButtonCategory.KM_DASHBOARD,
    [View.MY_OFFER]: AmplitudeButtonCategory.KM_OFFER_DETAILS
};

const preleadStatusToButtonCategoryMap: Record<HomeMatchPreleadStatus, AmplitudeButtonCategory> = {
    [HomeMatchPreleadStatus.PENDING]: AmplitudeButtonCategory.HOMEMATCH,
    [HomeMatchPreleadStatus.REJECTED]: AmplitudeButtonCategory.KM_REJECTED,
    [HomeMatchPreleadStatus.ACCEPTED]: AmplitudeButtonCategory.KM_SENT_OFFERS
};

export const getAmplitudeButtonCategoryByView = (viewType: View): AmplitudeButtonCategory => {
    return viewToButtonCategoryMap[viewType] || AmplitudeButtonCategory.UNKNOWN;
};

export const getAmplitudeButtonCategoryByPreleadStatus = (status: HomeMatchPreleadStatus): AmplitudeButtonCategory => {
    return preleadStatusToButtonCategoryMap[status];
};
import {HomeMatchPreleadStatus} from "@/features/home_match/types/HomeMatchPrelead";
import {View} from "@/features/km_app/types/View";

export enum AmplitudeButtonCategory {
    HOMEMATCH = "homematch",
    OFFER = "offer",
    KM_FAVOURITE = "km_favourite",
    KM_FAVOURITE_PICKER = "km_favourite_picker",
    KM_SENT_OFFERS = "hm_sent_offers",
    KM_SETTINGS = "km_settings",
    KM_REJECTED = "km_rejected",
    KM_OFFER_COMPARISON = "km_offer_comparison",
    KM_OFFER_DETAILS = "km_offer_details",
    KM_DASHBOARD = "km_dashboard",
    UNKNOWN = "unknown"
}

const viewToButtonCategoryMap: Partial<Record<View, AmplitudeButtonCategory>> = {
    [View.HOME_MATCH]: AmplitudeButtonCategory.HOMEMATCH,
    [View.FAVORITE]: AmplitudeButtonCategory.KM_FAVOURITE,
    [View.DISMISSED]: AmplitudeButtonCategory.KM_REJECTED,
    [View.APPLICATION_SENT]: AmplitudeButtonCategory.KM_SENT_OFFERS,
    [View.COMPARATOR]: AmplitudeButtonCategory.KM_OFFER_COMPARISON,
    [View.DASHBOARD]: AmplitudeButtonCategory.KM_DASHBOARD,
    [View.MY_OFFER]: AmplitudeButtonCategory.KM_OFFER_DETAILS
};

const preleadStatusToButtonCategoryMap: Record<HomeMatchPreleadStatus, AmplitudeButtonCategory> = {
    [HomeMatchPreleadStatus.PENDING]: AmplitudeButtonCategory.HOMEMATCH,
    [HomeMatchPreleadStatus.REJECTED]: AmplitudeButtonCategory.KM_REJECTED,
    [HomeMatchPreleadStatus.ACCEPTED]: AmplitudeButtonCategory.KM_SENT_OFFERS
};

export const getAmplitudeButtonCategoryByView = (viewType: View): AmplitudeButtonCategory => {
    return viewToButtonCategoryMap[viewType] || AmplitudeButtonCategory.UNKNOWN;
};

export const getAmplitudeButtonCategoryByPreleadStatus = (status: HomeMatchPreleadStatus): AmplitudeButtonCategory => {
    return preleadStatusToButtonCategoryMap[status];
};
